import  React, {
        useState, 
        useEffect }                         from "react";
import Draggable                            from "react-draggable";
import { Resizable }                        from "re-resizable";

export const FloatingContainer = ({ ...props }) => {

    const { Coordinate, 
            Visible = true,
            Width = 300,
            Height = 300,
            StackPosition = undefined,
            Draggable: IsDraggable = false,
            Resizable: IsResizable = false,
            children, 
                                                } = props;

    const defaultCoordinate = { x: 100, y: 100};

    const [position, setPosition] = useState(Coordinate || defaultCoordinate);

    useEffect(() => {
        if (Coordinate) {
            setPosition(Coordinate);
        }
    }, [Coordinate]);

    if (!Visible) {
        return null;
    }

    const container = (
        <Resizable
            defaultSize={{width: Width,height: Height }}
            enable={
                IsResizable
                    ? undefined
                    : {
                          top: false,
                          right: false,
                          bottom: false,
                          left: false,
                          topRight: false,
                          bottomRight: false,
                          bottomLeft: false,
                          topLeft: false
                      }
            }
            style={{
                position: "fixed",
                top: position.y,
                left: position.x,
                ...(StackPosition !== undefined && { zIndex: StackPosition}) 
            }}
        >
            {children}
        </Resizable>
    );

    return (
        IsDraggable ? 
            (
                <Draggable>
                    {container}
                </Draggable>
            ) 
        : 
            (
                container
            )
    );
};

